import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { formatLargeNumber } from "@/helpers/Helpers";
import type { CreateWaveOutcomeConfig } from "@/types/waves.types";
export default function CreateWaveOutcomesRowRepApprove(t0) {
  const $ = _c(22);
  const {
    outcome,
    removeOutcome
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-col-span-1"><h3 className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-white">Rep</h3></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `rep-category-${outcome.category}`;
  let t3;
  if ($[1] !== outcome.category || $[2] !== t2) {
    t3 = <p className="tw-mb-0 tw-truncate tw-text-sm tw-font-normal tw-text-white" data-tooltip-id={t2}>{outcome.category}</p>;
    $[1] = outcome.category;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `rep-category-${outcome.category}`;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== outcome.category || $[6] !== t4) {
    t6 = <Tooltip id={t4} style={t5}>{outcome.category}</Tooltip>;
    $[5] = outcome.category;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t6) {
    t7 = <div className="tw-col-span-4"><>{t3}{t6}</></div>;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = outcome.credit ?? 0;
  let t9;
  if ($[11] !== t8) {
    t9 = formatLargeNumber(t8);
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <div className="tw-col-span-4"><p className="tw-mb-0 tw-text-nowrap tw-text-sm tw-font-normal tw-text-white">{t9} Rep</p></div>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <svg className="tw-h-5 tw-w-5 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== removeOutcome) {
    t12 = <div className="tw-col-span-1 tw-flex tw-justify-end"><button onClick={removeOutcome} aria-label="Remove" className="tw-flex tw-h-8 tw-w-8 tw-transform tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-error tw-transition tw-duration-300 tw-ease-out hover:tw-bg-error/10 focus:tw-scale-90">{t11}</button></div>;
    $[16] = removeOutcome;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12 || $[20] !== t7) {
    t13 = <div className="tw-grid tw-w-full tw-grid-cols-10 tw-items-center tw-justify-between tw-gap-x-6 tw-rounded-lg tw-bg-gradient-to-r tw-from-primary-400/[0.15] tw-to-primary-400/[0.05] tw-px-5 tw-py-2 tw-ring-1 tw-ring-inset tw-ring-primary-400/10">{t1}{t7}{t10}{t12}</div>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t7;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return t13;
}